import { ProductMappingType, ProductTypeResponseApi } from "../type";

export function productMapper(data: ProductTypeResponseApi): ProductMappingType {
    let imagUrl = ''
    if (data.images.length > 0 && process.env.REACT_APP_AWS_S3_URL) {
        let imgFind = data.images.find((img) => img.typeimg === 'imgsmall')
        if (imgFind) {
            imagUrl =
                imgFind.path.substring(7, imgFind.path.length) + '/' ===
                    process.env.REACT_APP_AWS_S3_URL.substring(
                        7,
                        process.env.REACT_APP_AWS_S3_URL.length
                    )
                    ? imgFind.path + '/' + imgFind.imgsuffix
                    : imgFind.path
        }
    }

    const groups = data.productCustomerGroup.map((group) => group.customerGroup.name)

    return {
        id: data.id,
        code: data.code,
        name: data.name,
        category: data.classification.name,
        img: imagUrl,
        status: data.status,
        group : groups,
        created: data.created,
        updated: data.updated
    }
}